import {useQuery} from "@tanstack/react-query";
import {getLotteryGamesService} from "./lottery.service";
import type {LotteryGame} from "./lottery.types";

export const LOTTERY_GAMES_QUERY_KEY = ["lottery-games"] as const;

export const useLotteryGames = () => {
  const query = useQuery<LotteryGame[], Error>({
    queryKey: LOTTERY_GAMES_QUERY_KEY,
    queryFn: getLotteryGamesService,
    staleTime: 60_000,
  });

  return {
    games: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
